import api from './axiosInstance';
import { API_BASE_URL } from '../config';

export async function getCallTranscript(id) {
  try {
    const response = await api.post(
      `${API_BASE_URL}/CallTranscript/DownloadAudio`,
      null,
      {
        params: { id },
        responseType: 'blob',
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error downloading audio:', error);
    throw error;
  }
}

export const GetTranscriptById = async (id, signal) => {
  try {
    const response = await api.get(`${API_BASE_URL}/CallTranscript/${id}`, {
      signal,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching transcript:', error);
    throw error;
  }
};
